<template>
  <div class="v-chat-bubble row no-gutters">
    <div
      :class="[
        'd-flex',
        'v-chat-bubble__align',
        member && 'v-chat-bubble__align--right',
        fixedWidth && 'col-12 col-sm-11 col-md-8',
        fixedWidth && member && 'offset-sm-1 offset-md-4',
      ]"
    >
      <div v-if="caseworker" class="v-chat-bubble__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14">
          <path
            d="M9.09 8.121L8.11 7.02l.98-1.102c.45-.492.87-.918 1.484-.961 0-3.352-1.894-4.902-4.98-4.902C2.539.055.48 1.656.07 4.43l3.465.52c.313-1.24 1.047-1.638 1.996-1.638.946 0 1.52.434 1.52 1.235 0 .851-.739 1.117-1.375 1.117H5.09v2.707h.586c.636 0 1.375.266 1.375 1.117 0 .805-.574 1.239-1.52 1.239-.949 0-1.683-.403-1.996-1.637L.07 9.605c.442 2.825 2.418 4.375 5.524 4.375 3.035 0 4.98-1.55 4.98-4.898-.613-.043-1.035-.469-1.484-.96zm0 0"
            fill="#19476e"
          />
          <path
            d="M19.938 3.594V.34h-9.364v4.617c.035-.004.067-.008.102-.008.75 0 1.222.45 1.222 1.07 0 .418-.128.668-.507 1 .379.336.507.586.507 1.004 0 .618-.472 1.067-1.222 1.067-.035 0-.067-.004-.102-.008v4.617h3.531V9.441h5.016V6.187h-5.016v-2.59h5.832zm0 0"
            fill="#ed1c24"
          />
        </svg>
      </div>
      <div class="v-chat-bubble__wrapper">
        <div
          :class="[
            'v-chat-bubble__content',
            member && 'v-chat-bubble__content--member',
            caseworker && 'v-chat-bubble__content--caseworker',
          ]"
        >
          <slot />
        </div>
        <v-text v-if="date" size="small" :class="['v-chat-bubble__meta', member && 'v-chat-bubble__meta--member', 'd-print-none']">
          <v-date :date="date" calendar /><span v-if="caseworkerName" >,
            <v-text :tag="caseworkerUrl ? 'a' : 'span'" :href="caseworkerUrl">{{caseworkerName}}</v-text>
          </span><span v-if="caseworkerDepartment">, {{caseworkerDepartment}}</span>
        </v-text>
        <v-text class="d-none d-print-block">
          <span class="font-weight-bold">{{ memberName||caseworkerName }}</span><span v-if="caseworkerDepartment">, {{caseworkerDepartment}}</span>,
          <v-date :date="date" format="L [kl.] HH:MM" />
        </v-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Boolean,
      default: false
    },
    memberName: {
      type: String,
      default: null
    },
    caseworker: {
      type: Boolean,
      default: false
    },
    caseworkerName: {
      type: String,
      default: null
    },
    caseworkerUrl: {
      type: String,
      default: null
    },
    caseworkerDepartment: {
      type: String,
      default: null
    },
    fixedWidth: {
      type: Boolean,
      default: true
    },
    date: {
      type: [Number, String],
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../sass/component.scss";

.v-chat-bubble {
  &__align {
    &--right {
      justify-content: flex-end;

      @media print {
        justify-content: flex-start;
      }
    }
  }

  &__icon {
    display: flex;
    flex-shrink: 0;
    align-items: flex-end;
    margin-bottom: 28px;
    z-index: 2;

    svg {
      width: 20pt;
      height: 14pt;
    }
  }

  &__wrapper {
    display: flex;
    margin-left: $spacer;
    min-width: 0;
    flex-direction: column;
  }

  &__meta {
    color: theme-color("placeholder");

    a {
      color: theme-color("placeholder");
      text-decoration: underline;
    }

    &--member {
      text-align: right;
    }
  }

  &__content {
    position: relative;
    padding: $spacer;
    margin-bottom: 7px;
    border-radius: 10px;

    &--member {
      color: theme-color("white");
      background: theme-color("secondary");
      border-bottom-right-radius: 14px;

      a {
        color: theme-color("white");
      }
    }

    &--caseworker {
      background: theme-color("light");
      border-bottom-left-radius: 14px;

      a {
        color: theme-color("dark");
      }
    }

    &:before {
      content: "";
      position: absolute;
      z-index: 0;
      bottom: 0;
      height: 20px;
      width: 20px;
    }

    &:after {
      content: "";
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: 16px;
      height: 20px;
      background: theme-color("white");
    }

    &--caseworker {
      &:before {
        left: -7px;
        border-bottom-right-radius: 15px;
        background: theme-color("light");
      }

      &:after {
        left: -16px;
        border-bottom-right-radius: 10px;
      }
    }

    &--member {
      &:before {
        right: -7px;
        border-bottom-left-radius: 15px;
        background: theme-color("secondary");
      }

      &:after {
        right: -16px;
        border-bottom-left-radius: 10px;
      }
    }
  }

  @media print {
    // page-break-inside: avoid;
    margin-top: $spacer !important;

    & + & {
      margin-top: $spacer * 1.5 !important;
    }

    > div {
      margin-left: 0;
    }

    &__icon {
      display: none;
    }

    &__wrapper {
      margin-left: 0;
      flex-direction: column-reverse;

      >>> .v-text {
        font-size: 14px;
      }
    }

    &__content {
      background: none;
      color: theme-color("dark");
      padding: 0;

      &:before,
      &:after {
        content: none;
      }
    }
  }
}
</style>
